import styled, { css } from "styled-components"
import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import { Variant } from "."

export const Wrapper = styled(Box)<{ variant: Variant }>`
  display: flex;
  width: 100%;
  justify-content: space-between;

  ${(p) =>
    p.variant === "vertical" &&
    css`
      flex-direction: column;
    `}

  @media (max-width: ${breakpoints.small}) {
    align-items: center;
    flex-direction: column;
  }
`

export const Item = styled(Box)<{ icon?: string }>`
  display: flex;
  align-items: center;

  p {
    color: ${(p) => p.theme.colors.text.light};
    margin: 0.5rem 0;
  }

  svg {
    margin-right: 0.5rem;

    path {
      fill: ${(p) => p.theme.colors.text.light};
    }
  }

  ${(p) =>
    p.icon === "certificate" &&
    css`
      svg {
        width: 15px;
        height: 19px;
      }
    `}

  ${(p) =>
    p.icon === "truck" &&
    css`
      svg {
        width: 21px;
        height: 16px;
      }
    `}
`
